export default __webpack_public_path__ + "static/media/icon-domain.e27d8be8.svg";